// Exercise type filter options, shared by the Exercises page (type filter)
// and the merge wizard (same-type target grouping).
const TYPE_OPTIONS = [
  { value: 'all', label: 'All types' },
  { value: 'L', label: 'Lifts' },
  { value: 'R', label: 'SAQ + C' },
  { value: 'C', label: 'Circuits' },
  { value: 'S', label: 'Questionnaires' },
  { value: 'N', label: 'Notes' },
  { value: 'W', label: 'Warm-Ups' },
  { value: 'CD', label: 'Cooldowns' },
];

export default TYPE_OPTIONS;
